import axios from "axios";

var getOrganizations = async function(params) {
  return await axios.get("organizations", { params }).then(async (response) => {
    return response.data;
  });
};

var getSuppliers = async function(params) {
  return await axios.get("suppliers", { params }).then(async (response) => {
    return response.data;
  });
};

var getProductVariations = async function(params) {
  return await axios
    .get("product_variations", { params })
    .then(async (response) => {
      return response.data;
    });
};

var getOffers = async function(params) {
  return await axios
    .get("offers?populate=product_variation", { params })
    .then(async (response) => {
      return response.data;
    });
};

var getUsers = async function(params) {
  return await axios.get("users", { params }).then((response) => {
    return response.data;
  });
};

var getSellers = async function() {
  return await axios
    .get("users", { params: { role: "seller" } })
    .then((response) => {
      return response.data;
    });
};

var loadList = async function(type, params) {
  if (type == "organizations") {
    return await getOrganizations(params);
  } else if (type == "suppliers") {
    return await getSuppliers(params);
  } else if (type == "product_variations") {
    return await getProductVariations(params);
  } else if (type == "offers") {
    return await getOffers(params);
  } else if (type == "users") {
    return await getUsers(params);
  } else if (type == "sellers") {
    return await getSellers(params);
  }
};

export default {
  loadList,
};
